// app/javascript/manage_plan_modal.js
// Controls Manage Plan Modal opening, closing, and monthly/annual billing period toggle

(function () {
  function openModal () {
    const gateModal = document.getElementById('subscription_gate_modal')
    if (gateModal && typeof gateModal.close === 'function' && gateModal.open) {
      gateModal.close()
    }
    const modal = document.getElementById('manage_plan_modal')
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
    }
  }

  function closeModal () {
    const modal = document.getElementById('manage_plan_modal')
    if (modal && typeof modal.close === 'function') {
      if (modal.open) {
        modal.close()
      }
    }
  }

  window.openManagePlanModal = openModal
  window.closeManagePlanModal = closeModal

  function handleMonthlyToggle (modal, monthlyBtn, annualBtn) {
    monthlyBtn.classList.replace('text-black', 'text-[#043f42]')
    monthlyBtn.classList.replace('border-black', 'border-transparent')
    monthlyBtn.classList.replace('bg-transparent', 'bg-[#01d680]')
    monthlyBtn.classList.remove('border')

    annualBtn.classList.replace('text-[#043f42]', 'text-black')
    annualBtn.classList.replace('border-transparent', 'border-black')
    annualBtn.classList.replace('bg-[#01d680]', 'bg-transparent')
    annualBtn.classList.add('border')

    modal.querySelectorAll('.plan-price').forEach(el => {
      el.innerText = el.getAttribute('data-monthly') || el.innerText
    })
    modal.querySelectorAll('.price-period-label').forEach(el => {
      const defaultPeriod = el.getAttribute('data-default-period') || 'month'
      el.innerText = '/ ' + defaultPeriod
    })
    modal.querySelectorAll('.plan-cta-btn').forEach(btn => {
      if (btn.href && btn.href.includes('period=')) {
        const defaultPeriod = btn.getAttribute('data-default-period') || 'month'
        btn.href = btn.href.replace(/period=[^&]+/, 'period=' + defaultPeriod)
      }
    })
  }

  function handleAnnualToggle (modal, monthlyBtn, annualBtn) {
    annualBtn.classList.replace('text-black', 'text-[#043f42]')
    annualBtn.classList.replace('border-black', 'border-transparent')
    annualBtn.classList.replace('bg-transparent', 'bg-[#01d680]')
    annualBtn.classList.remove('border')

    monthlyBtn.classList.replace('text-[#043f42]', 'text-black')
    monthlyBtn.classList.replace('border-transparent', 'border-black')
    monthlyBtn.classList.replace('bg-[#01d680]', 'bg-transparent')
    monthlyBtn.classList.add('border')

    modal.querySelectorAll('.plan-price').forEach(el => {
      const annPrice = el.getAttribute('data-annual')
      if (annPrice && annPrice !== '') {
        el.innerText = annPrice
      }
    })
    modal.querySelectorAll('.price-period-label').forEach(el => {
      const planKey = el.getAttribute('data-plan-key')
      if (planKey === 'monthly') {
        el.innerText = '/ month (billed annually)'
      } else if (planKey === 'weekly') {
        el.innerText = '/ week (billed annually)'
      }
    })
    modal.querySelectorAll('.plan-cta-btn').forEach(btn => {
      if (btn.href && btn.href.includes('period=')) {
        const planKey = btn.getAttribute('data-plan-key')
        if (planKey === 'monthly' || planKey === 'weekly') {
          btn.href = btn.href.replace(/period=[^&]+/, 'period=year')
        }
      }
    })
  }

  // Global delegated click listener (CSP & Turbo resilient)
  document.addEventListener('click', function (e) {
    // 1. Open modal buttons
    const openBtn = e.target.closest('[data-action="open-manage-plan-modal"], [data-open-modal="manage_plan_modal"]')
    if (openBtn) {
      e.preventDefault()
      e.stopPropagation()
      openModal()
      return
    }

    // 2. Close modal buttons
    const closeBtn = e.target.closest('[data-action="close-manage-plan-modal"]')
    if (closeBtn) {
      e.preventDefault()
      e.stopPropagation()
      closeModal()
      return
    }

    const closeGateBtn = e.target.closest('[data-action="close-subscription-gate-modal"]')
    if (closeGateBtn) {
      e.preventDefault()
      e.stopPropagation()
      const gateModal = document.getElementById('subscription_gate_modal')
      if (gateModal && typeof gateModal.close === 'function') {
        gateModal.close()
      }
      return
    }

    // 3. Monthly toggle button inside modal
    const monthlyBtn = e.target.closest('#modal-billing-toggle-monthly')
    if (monthlyBtn) {
      e.preventDefault()
      e.stopPropagation()
      const modal = document.getElementById('manage_plan_modal')
      const annualBtn = document.getElementById('modal-billing-toggle-annual')
      if (modal && annualBtn) {
        handleMonthlyToggle(modal, monthlyBtn, annualBtn)
      }
      return
    }

    // 4. Annual toggle button inside modal
    const annualBtn = e.target.closest('#modal-billing-toggle-annual')
    if (annualBtn) {
      e.preventDefault()
      e.stopPropagation()
      const modal = document.getElementById('manage_plan_modal')
      const monthlyBtn = document.getElementById('modal-billing-toggle-monthly')
      if (modal && monthlyBtn) {
        handleAnnualToggle(modal, monthlyBtn, annualBtn)
      }
      return
    }

    // 5. Open Top-Up Modals
    const openTopUpBtn = e.target.closest('[data-action="open-top-up-modal"]')
    if (openTopUpBtn) {
      e.preventDefault()
      e.stopPropagation()
      const targetId = openTopUpBtn.getAttribute('data-target')
      const targetModal = targetId ? document.getElementById(targetId) : null
      if (targetModal) {
        targetModal.classList.remove('hidden')
      }
      return
    }

    // 6. Close Top-Up Modals
    const closeTopUpBtn = e.target.closest('[data-action="close-top-up-modal"]')
    if (closeTopUpBtn) {
      e.preventDefault()
      e.stopPropagation()
      const targetId = closeTopUpBtn.getAttribute('data-target')
      const targetModal = targetId ? document.getElementById(targetId) : closeTopUpBtn.closest('[id^="top-up-modal-"]')
      if (targetModal) {
        targetModal.classList.add('hidden')
      }
      return
    }

    // 7. Open Dialog (<dialog>) Modals (e.g. limitations)
    const openDialogBtn = e.target.closest('[data-action="open-dialog"]')
    if (openDialogBtn) {
      e.preventDefault()
      e.stopPropagation()
      const targetId = openDialogBtn.getAttribute('data-target')
      const dialog = targetId ? document.getElementById(targetId) : null
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal()
      }
      return
    }

    // 8. Close Dialog (<dialog>) Modals
    const closeDialogBtn = e.target.closest('[data-action="close-dialog"]')
    if (closeDialogBtn) {
      e.preventDefault()
      e.stopPropagation()
      const targetId = closeDialogBtn.getAttribute('data-target')
      const dialog = targetId ? document.getElementById(targetId) : closeDialogBtn.closest('dialog')
      if (dialog && typeof dialog.close === 'function') {
        dialog.close()
      }
      return
    }

    // 9. Dismiss Banners & Toasts
    const dismissBtn = e.target.closest('[data-action="dismiss-banner"], [data-action="dismiss-toast"]')
    if (dismissBtn) {
      e.preventDefault()
      e.stopPropagation()
      const targetId = dismissBtn.getAttribute('data-target')
      const targetEl = targetId ? document.getElementById(targetId) : dismissBtn.closest('#top-up-success-banner, #payment-success-toast')
      if (targetEl) {
        targetEl.remove()
      }
      return
    }

    // 10. Folios FAB Menu (Mobile)
    const fabTrigger = e.target.closest('#folios-fab-trigger, [data-action="toggle-folios-fab"]')
    if (fabTrigger) {
      e.preventDefault()
      e.stopPropagation()
      const menu = document.getElementById('folios-fab-menu')
      const backdrop = document.getElementById('folios-fab-backdrop')
      const icon = document.getElementById('folios-fab-icon')
      if (menu) {
        const isClosed = menu.classList.contains('hidden')
        if (isClosed) {
          menu.classList.remove('hidden')
          if (backdrop) backdrop.classList.remove('hidden')
          if (icon) icon.classList.add('rotate-45')
          fabTrigger.setAttribute('aria-expanded', 'true')
        } else {
          menu.classList.add('hidden')
          if (backdrop) backdrop.classList.add('hidden')
          if (icon) icon.classList.remove('rotate-45')
          fabTrigger.setAttribute('aria-expanded', 'false')
        }
      }
      return
    }

    const fabBackdrop = e.target.closest('#folios-fab-backdrop, [data-action="close-folios-fab"]')
    if (fabBackdrop) {
      e.preventDefault()
      e.stopPropagation()
      const menu = document.getElementById('folios-fab-menu')
      const icon = document.getElementById('folios-fab-icon')
      const trigger = document.getElementById('folios-fab-trigger')
      if (menu) menu.classList.add('hidden')
      fabBackdrop.classList.add('hidden')
      if (icon) icon.classList.remove('rotate-45')
      if (trigger) trigger.setAttribute('aria-expanded', 'false')
    }
  })
})()
